// extracted by mini-css-extract-plugin
export default {"dataInput":"Date_dataInput__c8YJh","dataInputError":"Date_dataInputError__Lua1t","container_input":"Date_container_input__CzWZx"};